import { RolesList } from './views';

export default {
  list: RolesList,
  name: 'role',
  label: 'Roles',
  to: '/role',
};
